import { createSelector } from '../selectorWrapper'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { pageSelectors, simpleSelectors } from '../basicState'
import { localeSelector, isRetailSelector } from '../requestContext'
import { isLiveEntityType } from '../../utils/entityTypes'
import { SeasonInfo } from '../../reducers/seasons'
import { isCerberusChildSelector } from '../pageContext'

export const amazonRatingSelector = createSelector(
  [
    isRetailSelector,
    simpleSelectors.pageTitleId,
    isCerberusChildSelector,
    pageSelectors.headerDetail,
    pageSelectors.offerAvailableOn,
  ],
  (
    isRetail: boolean,
    pageTitleId: string,
    isCerberusChild: boolean,
    detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps,
    offerAvailableOn?: string,
  ) => (
      detailFragment && pageTitleId && {
        amazonRating: detailFragment.amazonRating,
        isRetail,
        pageTitleId,
        offerAvailableOn,
        isCerberusChild
      } || undefined
    )
)

export const subtitlesSelector = createSelector(
  pageSelectors.headerDetail,
  (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps) => (detailFragment &&
    {
      subtitles: detailFragment.subtitles,
      isClosedCaption: detailFragment.isClosedCaption
    } || undefined)
)

export const releaseYearSelector = createSelector(
  pageSelectors.headerDetail,
  (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps) => (detailFragment && detailFragment.releaseYear &&
    { releaseYear: detailFragment.releaseYear } || undefined)
)

export const runtimeSelector = createSelector(
  pageSelectors.headerDetail,
  (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps) => (detailFragment && detailFragment.runtime &&
    { runtime: detailFragment.runtime } || undefined)
)

export const ratingBadgeSelector = createSelector(
  pageSelectors.headerDetail,
  (
    detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps,
  ) => (
    detailFragment && detailFragment.ratingBadge && {
      ratingBadge: detailFragment.ratingBadge,
    } || undefined)
)

export const dateTimeBadgeSelector = createSelector(
  [pageSelectors.headerDetail],
  (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps) => (
    detailFragment && detailFragment.pageDateTimeBadge && { dateTimeBadge: detailFragment.pageDateTimeBadge } || undefined)
)

export const imdbSelector = createSelector(
  pageSelectors.imdb,
  (imdbFragment?: WpsRuntime.atv.wps.ImdbFragmentModelProps) => (imdbFragment && { imdb: imdbFragment } || undefined)
)

export const locationSelector = createSelector(
  pageSelectors.headerDetail,
  (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps) => (detailFragment && detailFragment.location &&
    { location: detailFragment.location } || undefined)
)

export const xRaySelector = createSelector(
  pageSelectors.headerDetail,
  (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps) => (detailFragment && detailFragment.isXRay &&
    { isXRay: detailFragment.isXRay }) || undefined
)

export const hdrSelector = createSelector(
  pageSelectors.headerDetail,
  (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps) => (detailFragment && detailFragment.isHdr &&
    { isHdr: detailFragment.isHdr }) || undefined
)

export const uhdSelector = createSelector(
  pageSelectors.headerDetail,
  (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps) => (detailFragment && detailFragment.isUhd &&
    { isUhd: detailFragment.isUhd }) || undefined
)

export const adSelector = createSelector(
  pageSelectors.headerDetail,
  (detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps) => (detailFragment && detailFragment.isAd &&
    { isAd: detailFragment.isAd }) || undefined
)

export const seasonsBadgeSelector = createSelector(
  [localeSelector, pageSelectors.seasons, pageSelectors.headerDetail],
  (locale: string,
    seasons?: SeasonInfo[],
    detailFragment?: WpsRuntime.atv.wps.DetailFragmentModelProps
  ) => detailFragment && !isLiveEntityType(detailFragment.entityType) && seasons && seasons.length > 1 &&
  { numOfSeasons: seasons.length, locale } || undefined
)
